// @flow
import * as React from 'react';

type Args = {
  direction: 'horizontal' | 'vertical',
};

export const useResizable = ({direction}: Args) => {
  const ref = React.useRef<null | HTMLElement>(null);
  const [isDragging, setIsDragging] = React.useState(false);

  const handleMouseDown = () => {
    const handleDrag = (e: MouseEvent) => {
      if (ref.current) {
        setIsDragging(true);

        if (direction === 'vertical') {
          const containerHeight = ref.current?.offsetHeight ?? 0;

          if (ref.current?.style) {
            ref.current.style.height = `${containerHeight - e.movementY}px`;
          }
        } else {
          const containerWidth = ref.current?.offsetWidth ?? 0;

          if (ref.current?.style) {
            ref.current.style.width = `${containerWidth + e.movementX}px`;
          }
        }
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);

      document.removeEventListener('mousemove', handleDrag);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleDrag);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return {ref, isDragging, handleMouseDown};
};
